module.exports = __webpack_public_path__ + "static/media/fottur.8ca02b6a.svg";